import { Component, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PaseosComponent } from '../paseos.component';
import { QueryService } from '../../comun/services/query.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { LoaderService } from '../../comun/services/loader.service';
import { GlobalConstants } from '../../global-constants';
import { forkJoin } from 'rxjs';

interface Respuesta {
  resultado: string;
}

@Component({
  selector: 'app-newedit',
  templateUrl: './newedit.component.html',
  styleUrls: ['./newedit.component.css']
})
export class NeweditComponent {
  @Input() paseo: any = {pa_id: 0, pa_titulo: ''};
  imageUrl: string | null = null;
  defaultImage: string = GlobalConstants.urlServer + 'img/camarafotos.png';
  llamadas: any[] = [];
  error: string = '';

  constructor(public paseosComp: PaseosComponent,
              public query: QueryService,
              private toastr: ToastrService,
              private loader: LoaderService,
              private http: HttpClient) {}

  ngOnInit() {
    this.paseosComp.getMascotas();
    this.subirScroll();
  }

  ngOnafterViewInit() {
    setTimeout(() => {
      this.subirScroll();
    }, 0);
  }

  subirScroll() {
    window.scrollTo({ top: 130, behavior: 'smooth' });
  }

  seleccionarMascota(mascota: any) {
    mascota.checked = !mascota.checked;
  }

  validarPaseo() {
    const totalChecked = this.paseosComp.mascotas.filter(m => m.checked).length;    
    if (this.paseo.pa_titulo == '')
      this.error = 'Ponle un título a tu paseo';
    else if (this.paseo.pa_descripcion == '')
      this.error = 'Describe tu paseo';
    else if (this.paseo.pa_ubicacion == '')
      this.error = 'Especifica donde será el paseo';
    else if (this.paseo.pa_fecha == '')
      this.error = 'Indica cuando será el paseo';
    else if (this.paseo.pa_hora == '')
      this.error = 'Indica a que hora será el paseo';
    else if (totalChecked == 0)
      this.error = 'Elige mascota con quien pasear';
    //if (this.error != '')
    //  this.toastr.error(this.error, 'Error');
    return this.error;
  }

  publicarPaseo() {    
    this.error = '';
    if (this.validarPaseo() == '') {
      this.loader.show();
      this.query.query('paseos', 'PUBLICAR', { paseo: this.paseo, mascotas: this.paseosComp.mascotas }).subscribe((resultado:any) => {
        this.llamadas = [];
        this.subirFoto();
        if (this.llamadas.length > 0) {
          // Convertir array → objeto para evitar deprecación
          const llamadasObj = this.llamadas.reduce((acc, obs, i) => {
            acc[i] = obs;
            return acc;
          }, {} as { [key: string]: any });
          forkJoin(llamadasObj).subscribe(resultados => {
            this.query.query('paseos', 'BORRARFOTO', { foto_cabecera_id: this.paseo.foto_cabecera_id }).subscribe((resultado:any) => {
              this.paseosComp.getMisDatos();
              this.paseosComp.publicar = false;
              this.loader.hide();
            });
            if (this.paseo.pa_id == 0)
              this.enviarMail('NUEVO PASEO');
            else
              this.enviarMail('EDITAR PASEO');
          });
        } else {
          if (this.paseo.foto_cabecera_grande == null) {
            this.query.query('paseos', 'BORRARFOTO', { foto_cabecera_id: this.paseo.foto_cabecera_id }).subscribe((resultado:any) => {
              this.paseosComp.getMisDatos();
              this.paseosComp.publicar = false;
              this.loader.hide();
            });
          } else {
            this.paseosComp.getMisDatos();
            this.paseosComp.publicar = false;
            this.loader.hide();
          }
          if (this.paseo.pa_id == 0)
            this.enviarMail('NUEVO PASEO');
          else
            this.enviarMail('EDITAR PASEO');
        }
      });
    }
  }

  subirFoto() {
    if (this.imageUrl != null) {
      const formData = new FormData();
      formData.append('data', this.paseo.foto_cabecera_grande || this.defaultImage);
      formData.append('principal', '');
      formData.append('tipo', 'PAP');
      formData.append('tipo_id', this.paseo.pa_id);
      const token = localStorage.getItem('token');
      const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
      this.llamadas.push(this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers }));
    }
  }

  borrarFoto(id: number = 0) {
    this.query.query('paseos', 'BORRARFOTO', { foto_cabecera_id: id }).subscribe((resultado:any) => {
    });
  }

  borrarPaseo() {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar este paseo?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.loader.show();
        this.query.query('paseos', 'BORRAR', { paseo: this.paseo }).subscribe((resultado:any) => {
          this.paseosComp.getPaseos();
          this.paseosComp.publicar = false;
          this.loader.hide();
          this.enviarMail('BORRAR PASEO');
        });
      } else {
      }
    });
  }

  cancelar() {
    this.paseosComp.publicar = false;
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.paseo.foto_cabecera_grande = reader.result as string;
        this.imageUrl = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }  

  quitarFoto() {
    this.paseo.foto_cabecera_grande = null;
    this.imageUrl = null;
  }

  enviarMail(cual: string = '') {
    let contenido = '';
    let params = { plantilla: 'general.html',
                   us_id: 0, // administradores
                   tipo: 'ACTIVIDAD',
                   asunto: '',
                   contenido: '',
                   botonurl: GlobalConstants.urlWeb + '/wp-admin/',
                   boton: '',
                   estado: 'pendiente',
                   contacto: '' // al email de contacto del usuario
                 };
    switch (cual) {
      case 'NUEVO PASEO':
        // Enviar email a los administradores
        contenido = '<p>Hola equipo,</p>' +
                        '<p>Se ha publicado un nuevo paseo en iGuau.</p>' +
                        '<p>' +
                        'ID: <b>' + this.paseo.pa_id + '</b>' +
                        '<br>Usuario: <b>' + this.paseo.user_email + '</b>' +
                        '<br>Paseo: <b>' + this.paseo.pa_titulo + '</b>' +
                        '<br>Ubicación: <b>' + this.paseo.pa_ubicacion + '</b>' +
                        '</p>' +
                        '<p>Un saludo,<br>El equipo de iGuau</p>';
        params = { plantilla: 'general.html',
                      us_id: 0, // administradores
                      tipo: 'ACTIVIDAD',
                      asunto: 'Nuevo paseo en iGuau',
                      contenido: contenido,
                      botonurl: GlobalConstants.urlWeb + '/wp-admin/',
                      boton: '',
                      estado: 'pendiente',
                      contacto: '' // al email de contacto del usuario
                    };
        this.query.enviarMail(params).subscribe((resultado:any) => {
        });
        break;
      
      case 'EDITAR PASEO':
        // Enviar email a los administradores
        contenido = '<p>Hola equipo,</p>' +
                        '<p>Se ha modificado un paseo en iGuau.</p>' +
                        '<p>' +
                        'ID: <b>' + this.paseo.pa_id + '</b>' +
                        '<br>Usuario: <b>' + this.paseo.user_email + '</b>' +
                        '<br>Paseo: <b>' + this.paseo.pa_titulo + '</b>' +
                        '<br>Ubicación: <b>' + this.paseo.pa_ubicacion + '</b>' +
                        '</p>' +
                        '<p>Un saludo,<br>El equipo de iGuau</p>';
        params = { plantilla: 'general.html',
                      us_id: 0, // administradores
                      tipo: 'ACTIVIDAD',
                      asunto: 'Paseo editado en iGuau',
                      contenido: contenido,
                      botonurl: GlobalConstants.urlWeb + '/wp-admin/',
                      boton: '',
                      estado: 'pendiente',
                      contacto: '' // al email de contacto del usuario
                    };
        this.query.enviarMail(params).subscribe((resultado:any) => {
        });
        break;

      case 'BORRAR PASEO':
        // Enviar email a los administradores
        contenido = '<p>Hola equipo,</p>' +
                        '<p>Se ha borrado un paseo en iGuau.</p>' +
                        '<p>' +
                        'ID: <b>' + this.paseo.pa_id + '</b>' +
                        '<br>Usuario: <b>' + this.paseo.user_email + '</b>' +
                        '<br>Paseo: <b>' + this.paseo.pa_titulo + '</b>' +
                        '<br>Ubicación: <b>' + this.paseo.pa_ubicacion + '</b>' +
                        '</p>' +
                        '<p>Un saludo,<br>El equipo de iGuau</p>';
        params = { plantilla: 'general.html',
                      us_id: 0, // administradores
                      tipo: 'ACTIVIDAD',
                      asunto: 'Paseo borrado en iGuau',
                      contenido: contenido,
                      botonurl: GlobalConstants.urlWeb + '/wp-admin/',
                      boton: '',
                      estado: 'pendiente',
                      contacto: '' // al email de contacto del usuario
                    };
        this.query.enviarMail(params).subscribe((resultado:any) => {
        });
        break;
    }
  }

}
